import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TeamRostersReportModel } from 'src/app/reports/team-rosters-report/team-rosters-report.model';
import {
  ModalConfirmationComponent,
  ModalConfirmationModel
} from 'src/shared-app-portal/components/modal-confirmation/modal-confirmation.component';
import { Workspace } from 'src/app/shared/models/workspace/workspace';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';

@Component({
  selector: 'app-recent-accepts-item',
  templateUrl: './recent-accepts-item.component.html',
  styleUrls: ['./recent-accepts-item.component.scss'],
  standalone: false
})
export class RecentAcceptsItemComponent implements OnInit {
  @Input() item: TeamRostersReportModel;
  @Input() workspaces: Workspace[];
  @Input() activeWorkspaceIsOrg: boolean;

  public confirmationRef: MatDialogRef<ModalConfirmationComponent>;

  constructor(
    private router: Router,
    private workspaceService: WorkspaceService,
    private dialog: MatDialog
  ) {}
  ngOnInit(): void {}

  onItemClicked(model: TeamRostersReportModel) {
    if (!model.teamWorkspaceId || !this.activeWorkspaceIsOrg) {
      this.router.navigate([
        '/teams',
        model.teamId,
        'seat',
        model.seatId,
        'personDetails',
        model.personId
      ]);
    } else {
      let ws = this.workspaces.find((x) => x.id == model.teamWorkspaceId);
      this.openChangeWorkspaceDialog(model, ws);
    }
  }

  private openChangeWorkspaceDialog(model: TeamRostersReportModel, workspace: Workspace) {
    const data: ModalConfirmationModel = {
      simpleDialog: false,
      title: `Open "${model.teamName}" in the "${workspace.name}" workspace?`,
      description: `This team is located in the "${workspace.name}" workspace. Do you want to go to this workspace so you can view and edit this team?`,
      action: null,
      textMatcherValue: '',
      delete: false,
      okButtonText: 'Go to Team',
      okButtonId: 'modal-recent-accepts'
    };

    this.confirmationRef = this.dialog.open(ModalConfirmationComponent, {
      data
    });

    this.confirmationRef.afterClosed().subscribe((result) => {
      if (result) {
        this.workspaceService.updateActiveWorkspace(
          workspace,
          `/teams/${model.teamId}/personDetails/${model.personId}`
        );
      }
      this.confirmationRef = null;
    });
  }
}
